module.exports = __webpack_public_path__ + "static/img/2.2b0fde0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/4/eng/2.png
// module id = kWWV
// module chunks = 0